/* eslint-disable no-debugger */
import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { connect } from 'react-redux'
import { saveMusicStatus, setHasInteracted } from '../../reducers/sound'

const mapStateToProps = (state) => {
    return {
        soundState: state.sound
    }
}

const SoundController = ({ dispatch, soundState }) => {
    const toggleMusic = (e) => {
        dispatch(setHasInteracted())
        dispatch(saveMusicStatus())
    }

    return (
        <button className={`nav-sound icon-link ${soundState.musicEnabled > 0 ? 'sound-on' : 'sound-off'}`} onClick={toggleMusic} aria-label="Toggle Music">
            <FontAwesomeIcon icon={soundState.musicEnabled > 0 ? 'volume-high' : 'volume-mute'} aria-hidden="true" />
        </button>
    )
}

export default connect(mapStateToProps)(SoundController)
